module.exports = __webpack_public_path__ + "img/email.fa45b91b.svg";